import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { registerServiceWorker } from './registerServiceWorker';

// Import Capacitor and make it globally available
try {
  const { Capacitor } = require('@capacitor/core');
  window.Capacitor = Capacitor;
  console.log('Capacitor loaded, isNative:', Capacitor.isNativePlatform());
} catch (e) {
  console.log('Capacitor not available (running in browser)');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Offline shell for field crews — lets the app open in a dead zone. Web only;
// see registerServiceWorker.js.
registerServiceWorker();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();